export const calculateStyle = (corner) => ({
  '--tileBackgroundCorner': `${corner}px`,
  '--tileBackgroundInnerCorner': `${corner - 1}px`,
});
